export enum LoyaltyLevelYears {
  BronzeYearStart = 5,
  SilverYearStart = 10,
  GoldYearStart = 25,
  Gold50YearStart = 50,
}
